import { Flex } from 'antd';

const AccountDisabledPopover: React.FC<{ explanation: string }> = ({
  explanation,
}) => {
  return (
    <Flex vertical={true}>
      <b>Your Giide subscription has ended.</b>
      <span>{explanation}</span>
    </Flex>
  );
};

export default AccountDisabledPopover;
